module.exports = __webpack_public_path__ + "static/media/history.1e3764a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/history.png
// module id = 1075
// module chunks = 0